import classNames from "classnames";
import {Product} from "@/entities/product";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import {CatalogCard} from "@/widgets/catalog-card";
import {useProductGarniturCarousel} from "../model/hooks/useProductGarniturCarousel";
import {Link} from "@/shared/ui/Link";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import styles from "./ProductGarniyur.module.scss";

type Props = {
    products: Product[];
    collection: string | null;
    collectionAlias: string | null;
}

export const ProductGarnitur = ({products, collection, collectionAlias}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useProductGarniturCarousel();

    const {registerView} = useViewItemBatcher();

    if (products.length === 0) {
        return null;
    }

    return (
        <div className={styles.container}>
            <p className={styles.title}>Украшения из гарнитура</p>
            <div className={styles.carousel}>
                <div ref={carouselRef} className={styles.carouselViewport}>
                    <div className={styles.carouselContainer}>
                        {products.map((product, i) => {
                            return (
                                <CatalogCard
                                    key={product.id}
                                    product={product}
                                    className={styles.carouselSlide}
                                    index={i + 1}
                                    registerView={registerView}
                                />
                            );
                        })}
                    </div>
                </div>
                {products.length > 1 && (
                    <>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                            onClick={onPrevButtonClick}
                        >
                            <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                        </button>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                            onClick={onNextButtonClick}
                        >
                            <Svg id={`arrowRight`} className={styles.arrowIcon} />
                        </button>
                    </>
                )}
            </div>
            {collection && (
                <Link href={`/catalog/${collectionAlias}`}>
                    <Button variant={`secondary`} fullWidth>Смотреть коллекцию</Button>
                </Link>
            )}
        </div>
    );
}
